import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { Subscription } from 'rxjs';
import { Language, LayoutService } from '../../shared/services/layout.service';
import { ConnexionInformationsValidatorService } from '../../shared/services/connexion-informations-validator.service';
import { GlobalApps } from '../../shared/helpers/settings';

@Component({
	selector: 'app-Registration',
	templateUrl: './registration.component.html',
	styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit, OnDestroy {
	// public user: firebase.User;
	public registrationForm: FormGroup;
	public show: boolean = false;
	public emailError: string = '';
	public usernameError: string = '';
	public passwordError: string = '';
	public errorMessage: string;
	public successMessage: string;
	private loginSubscription: Subscription;
	public selectedLang: Language;

	constructor(
		private fb: FormBuilder,
		public router: Router,
		private authService: AuthService,
		private connexionInformationsValidatorService: ConnexionInformationsValidatorService,
		private layoutService: LayoutService
	) {}

	ngOnInit() {
		this.initForm();
		this.selectedLang = this.layoutService.getCurrentLanguage();
	}

	ngOnDestroy() {
		this.loginSubscription?.unsubscribe();
	}

	registration() {
		this.errorMessage = null;
		this.emailError = this.notValidateEmail(this.registrationForm?.value.email)?.trim();
		this.usernameError = this.notValidateUsername(this.registrationForm?.value.username)?.trim();
		this.registrationForm.value.phoneNumber = this.registrationForm?.value?.phoneNumber?.trim();
		this.registrationForm.value.firstName = this.registrationForm?.value?.firstName?.trim();
		this.registrationForm.value.lastName = this.registrationForm?.value?.lastName?.trim();
		if (this.emailError) return;
		if (this.usernameError) return;
		if (this.passwordError) return;
		if (this.registrationForm.invalid) {
			this.registrationForm.markAllAsTouched();
			return;
		}
		if (this.registrationForm.invalid) return;
		// Send user registration data to your server or perform desired actions
		const registrationData = this.registrationForm.value;
		const applications = GlobalApps.map(app => {
			app.isActive = true;
			return app;
		});
		this.authService.register(registrationData, applications).subscribe(
			res => {
				if (res?.status === 404) {
					this.errorMessage = res.message;
					this.successMessage = null;
				} else if (res?.status === 201) {
					this.successMessage = res.message;
					this.errorMessage = null;
					setTimeout(_ => {
						this.successMessage = 'Congratulations on joining our community';
					}, 1000);
					setTimeout(_ => {
						this.router.navigate(['/auth/congratulations']);
					}, 2000);
				}
			},
			err => {
				this.errorMessage = err;
				this.successMessage = null;
				return;
			}
		);
	}
	notValidateEmail(email) {
		return this.connexionInformationsValidatorService.validateEmail(email);
	}
	notValidateUsername(username) {
		return this.connexionInformationsValidatorService.validateUsername(username);
	}
	validatePassword() {
		this.passwordError = this.connexionInformationsValidatorService.validatePasswordComplexity(
			this.registrationForm?.value.password
		);
	}
	private initForm() {
		// Define the regular expression pattern for Moroccan phone numbers
		// The pattern allows for the following formats: 0601204927 and +212601249247
		const moroccanPhoneNumberPattern = /^(?:\+212|0)[1-9]\d{8}$/;
		const passwordComplex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#_.-])[A-Za-z\d@$!%*?&#_.-]{8,}$/;
		this.registrationForm = this.fb.group({
			firstName: ['', [Validators.required]],
			lastName: ['', [Validators.required]],
			phoneNumber: ['', [Validators.required, Validators.pattern(moroccanPhoneNumberPattern)]],
			username: ['', [Validators.required]],
			email: ['', [Validators.required, Validators.email]],
			password: ['', [Validators.required, Validators.pattern(passwordComplex)]]
		});
	}
	get phoneNumber() {
		return this.registrationForm.get('phoneNumber');
	}
}
